import {
    createOverlayComponent,
    IOverlayBaseBusinessLogic,
} from '@vfde-brix/overlay';

/**
 * ARRGH
 *
 * Ein Overlay kann man leider nicht einfach so auf die Seite schmeißen.
 * Zumindest nicht, wenn man seinen Inhalt noch nicht hat
 *
 * Dieser Overlay Service kümmert sich um zwei Dinge:
 *
 * 1) Finde alle Links, die aus Brix kommen und über das Data-Attribut von sich behaupten, dass sie ein Overlay öffnen
 * 2) OnClick -> Im Hintergrund die href laden und das Html in ein Overlay packen und dieses öffnen
 *
 */

/**
 *
 */
export const getLinksThatShouldOpenInAnOverlay = () => {
    const allLinks = document.getElementsByTagName('a');

    const overlayLinks = [];

    for (const link of allLinks) {
        if (link.className.lastIndexOf('brix') === -1) {
            continue;
        }

        if (link.getAttribute('data-action') === 'overlay') {
            overlayLinks.push(link);
        }
    }

    return overlayLinks;
};

/**
 *
 */
export const fetchOverlayContent = (url: string) => {
    fetch(url)
        .then(function (response) {
            return response.text();
        })
        .then(function (html) {
            const aDiv = document.createElement('div');
            aDiv.setAttribute('id', 'brix-standalone-overlay');

            document.getElementsByTagName('body')[0].append(aDiv);

            const business: IOverlayBaseBusinessLogic = {

                onClose: () => {
                    aDiv.remove();
                },

            };

            const dynamicOverlay01 = createOverlayComponent(aDiv, { business });

            dynamicOverlay01.injectContent(html);
            dynamicOverlay01.open();

            try {
                (window as any).vf.toggle.init(dynamicOverlay01.getOverlayContentContainer());

                // Initialize simplicity responsive tables
                if ((window as any).vf['responsive-table']) {
                    (window as any).vf['responsive-table'].init();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        });
};
